import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const SecurityPage = lazy(() => import('./SecurityPage'));

export const securityRoutes: RouteObject[] = [
  {
    path: 'security',
    element: (
      <ProtectedRoute action="security:view">
        <SecurityPage />
      </ProtectedRoute>
    ),
  },
];
